import _ from 'lodash'
import { ConceptStatus } from '@fusion-advantage/backcompat'
import { L2Dialog, L2DialogActions, L2DialogContent } from '../l2/L2Dialog'
import { L3Image, L3ImageFormat } from './L3Image'
import { L1ReasonableButton } from '../l1/L1Button'
import { faThumbsUp } from '@fortawesome/pro-solid-svg-icons'

interface L3ImageDialogProps {
	format: L3ImageFormat
	conceptStatus: ConceptStatus | null,
	show: Boolean,
	onClose: () => void,
}

const L3ImageDialog = ({ format, conceptStatus, show, onClose }: L3ImageDialogProps) => {
	return (
		<L2Dialog
			show={show}
			onClose={onClose}
			title="Image View"
		>
			<L2DialogContent height="40vh">
				<L3Image
					format={format}
					conceptStatus={conceptStatus}
				/>
			</L2DialogContent>
			<L2DialogActions>
				<L1ReasonableButton
					label="Done"
					icon={faThumbsUp}
					onClick={onClose}
				/>
			</L2DialogActions>
		</L2Dialog>
	)
}

export default L3ImageDialog
